import React from 'react';
function MenuFooter() {
    return React.createElement("div", { className: "elmo-nav-footer" }, "[Footer]");
}
export default MenuFooter;
